<template>
    <div>
        <div class="flex my-2 items-center space-x-2">
            <div class="w-[10%]">
                Utilisation:
            </div>
            <b-dropdown :text="currentRequest.useCase">
                <b-dropdown-item
                    v-for="(useCase, index) in availableUseCases"
                    :key="index"
                    :value="useCase.name"
                    @click="() => currentRequest.useCase = useCase.name">
                    {{ useCase.name }}
                </b-dropdown-item>
            </b-dropdown>

        </div>
        <div v-if="currentRequest.useCase === 'Nos scénarios'">
            <div v-for="scenario in ourScenarios">
                <button>
                    <a :href="'data:application/json,' + JSON.stringify(scenario.json)" :download="scenario.name + '.json'">{{ scenario.name }}</a>
                </button>
            </div>
        </div>
    </div>

</template>

<script>
	import Autocomplete from "@trevoreyre/autocomplete-vue";
	var clone = require("clone");

     export default {
		name: "helper_n8n",
		components: {
			Autocomplete,
		},
		props: {
			editorRef: Object,
			availableColumns: Array,
			initialValue: Object,
            prevData: Array,
		},
		data() {
			return {
                currentRequest: {
                    useCase: 'Nos scénarios',
                },
                availableUseCases: [
                    {name: "Nos scénarios", value: "scenarios"},
                    {name: "Appeler un webhook n8n", value: "webhook"},],
                ourScenarios: [
                    {name: "Google sheets", json: {toto: "tata"} }, // * json pris dans le backend
                    {name: "Airtable", json: {toto: "tata"}}, // * json pris dans le backend
                ]
			};
		},
		methods: {
		},
		watch: {
			
		},
		mounted() {

		},
	};

</script>